import { Component, Input, forwardRef } from '@angular/core';
import { FormBuilder, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { portalConst } from '@app/config';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

@Component({
  selector: 'app-upload-audio-element',
  templateUrl: './upload-audio-element.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => UploadAudioElementComponent),
    },
  ],
  standalone: false,
})
export class UploadAudioElementComponent {
  @Input() public submitted = false;
  public preview: string;

  public form = this.formBuilder.group({
    id: undefined,
    hash: undefined,
    nome_arquivo: [undefined, [Validators.required]],
    extensao: [undefined, [Validators.required]],
    file: [undefined, [Validators.required]],
  });

  public config: DropzoneConfigInterface = {
    clickable: true,
    url: `${portalConst.api.usuario}/temp-upload/v1/file`,
    params: {
      pesoMaximo: 30000,
      stringKbMb: 'Mb',
    },
    createImageThumbnails: false,
    maxFiles: 1,
    maxFilesize: 30,
    acceptedFiles: '.mp3,.mpga',
    previewsContainer: false,
  };

  constructor(private formBuilder: FormBuilder) {}

  public onUpload(data: any) {
    this.form.patchValue(data);
    this.preview = portalConst.aws.s3Snv + '/temp-upload-files/' + data.file;
    this.onSend();
  }

  public onDelete(): void {
    this.form.reset();
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public writeValue(data: any): void {
    if (!!data) {
      this.form.patchValue(data);
      if (!!data.file) {
        this.preview = data.file;
      }
    } else {
      this.form.reset();
    }
  }

  private onSend(): void {
    this.onTouched();
    if (!!this.form.value) {
      this.onChange(this.form.value);
    } else {
      this.onChange(undefined);
    }
  }

  public onTouched = () => true;
  private onChange = (_: any) => true;
}
